<template>
  <FormGroup
    :label="label"
    :inputId="idCalc"
    :errors="errorsCalc"
    :successes="successes"
    :description="description"
  >
    <template #label>
      <!-- <slot name="label" /> -->
      <slot name="label">
        <label :for="idCalc" v-if="label" class="tw-mb-2" :class="labelType" v-html="label" />
      </slot>
    </template>
    <select
      v-if="!loading"
      class="form-select"
      :class="[{ 'is-invalid': errorsCalc, 'is-valid': successes }, inputType]"
      :data-test="
        testId ||
        `form-${name ? `${name.toLowerCase().replaceAll(' ', '-')}-select` : 'select'}-input`
      "
      :id="idCalc"
      :name="name"
      :value="value || modelValue"
      :disabled="disabled"
      :tabindex="tabindex"
      @input="emitInput"
      @change="emitChange"
    >
      <slot>
        <option
          :key="val"
          v-for="(option, val) in options"
          :value="val"
          :data-test="`${testId}-${option}-option`"
        >
          {{ option }}
        </option>
      </slot>
    </select>
    <div v-else class="loading !tw-h-8" />
  </FormGroup>
</template>

<script>
import { computed } from "vue";
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";

export default {
  name: "FormSelect",
  components: {
    FormGroup,
  },
  mixins: [FormMixin],
  emits: ["change", "input", "update:modelValue"],
  props: {
    options: {
      type: Array,
      validator: (values) => {
        if (!Array.isArray(values)) {
          return false;
        }

        return values;
      },
    },
    modelValue: [String, Number, Boolean],
    value: [String, Number, Boolean],
    disabled: Boolean,
    variant: String,
    loading: {
      type: Boolean,
      default: false,
    },
    testId: String,
  },
  setup(props, { emit }) {
    const labelTypeList = {
      light: "",
    };
    const labelType = computed(() =>
      !labelTypeList[props.variant] ? labelTypeList.light : labelTypeList[props.variant]
    );
    const inputTypeList = {
      light: "",
    };
    const inputType = computed(() =>
      !inputTypeList[props.variant] ? inputTypeList.light : inputTypeList[props.variant]
    );
    const emitChange = (e) => emit("change", e.target.value);
    const emitInput = (e) => {
      const value = e.target.value;
      emit("input", value);
      emit("update:modelValue", value);
    };

    return {
      emitChange,
      emitInput,
      labelType,
      inputType,
    };
  },
};
</script>
